import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader';
import ServicesIcon from '@material-ui/icons/PhoneAndroid';
import Divider from '@material-ui/core/Divider';
import ViewMoreLink from '../../../components/ViewMoreLink/ViewMoreLink';

import { getString } from '../../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'services';

class ServiceLandingCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, title, summary, slug, action } = this.props;

    return (
      <div className={classes.root}>
        <Card className={`${classes.card} Card`}>
          <IndentedCardHeader
            title={
              <React.Fragment>
                <Typography variant='h3' className={classes.titleText}>
                  {title}
                </Typography>
              </React.Fragment>
            }
            avatar={<ServicesIcon />}
            classes={{
              avatar: classes.icon,
            }}
          />
          <CardContent className={classes.cardContent}>
            <Divider className={classes.dividerTop} />
            <div
              className={classes.contentContainer}
              onClick={() => action(slug)}
            >
              <div className={classes.cardText}>
                <Typography>{summary}</Typography>
              </div>
              <div className={classes.buttonContainer}>
                <ViewMoreLink
                  action={() => action(slug)}
                  label={getString(stringsComponent, 'VIEW_DETAILS_LABEL')}
                  standAlone
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

ServiceLandingCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(ServiceLandingCard);
